import React from 'react';
import { CheckIcon, GiftIcon, AlertTriangleIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="bg-steel-100 py-12 sm:py-16" aria-labelledby="bonus-title" data-id="element-85" data-mp="1ckoa6o3h9qef">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-86" data-mp="18jukpqae03jf">
        <h2 id="bonus-title" className="flex flex-col items-center gap-2 text-center font-display text-[1.75rem] font-extrabold uppercase leading-[1.02] text-ink-900 sm:text-4xl" data-id="element-87" data-mp="18lffnh0m5oht">
          <GiftIcon className="h-8 w-8 text-gold-600" aria-hidden="true" data-id="element-88" data-mp="208nwnbtraun7" />
          Exclusive bonuses — included free today
        </h2>
        <p className="mt-3 text-center text-[15px] font-semibold uppercase tracking-wide text-ink-700 sm:text-lg" data-id="element-89" data-mp="1ralsineq7lvp">
          Today you’ll also receive these 5 premium bonus systems
        </p>
        <p className="mx-auto mt-3 w-fit rounded-full bg-ink-950 px-4 py-2 text-center text-sm font-bold uppercase tracking-wide text-gold-400" data-id="element-90" data-mp="fv6xhp62v438">
          Combined value: $235 — included free
        </p>

        <div className="mt-8 space-y-6" data-id="element-91" data-mp="1jt9nae9y8lu0">
          {bonuses.map(bonus => <article key={bonus.tag} className="-mx-4 overflow-hidden border-y border-ink-900/10 bg-white shadow-sm sm:mx-0 sm:rounded-2xl sm:border" data-id="element-92" data-mp="15sywfb8n378u">
              <img src={bonus.image} alt={`${bonus.title} — included bonus materials`} className="block w-full bg-white" width={1256} height={1256} loading="lazy" data-id="element-93" data-mp="w35m0dk8gy66" />
              <div className="p-4 sm:p-6" data-id="element-94" data-mp="n4bswx642pxd">
                <div className="flex flex-wrap items-center gap-2" data-id="element-95" data-mp="r3kma0x8olse">
                  <span className="rounded-md bg-ink-950 px-2.5 py-1 font-display text-xs font-extrabold uppercase tracking-[0.15em] text-gold-400" data-id="element-96" data-mp="r1q0kke58pn9">
                    🎁 {bonus.tag}
                  </span>
                  <span className="rounded-md bg-green-600 px-2.5 py-1 font-display text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-97" data-mp="2jsjvsi9tdhie">
                    Value: {bonus.value}
                  </span>
                </div>

                <h3 className="mt-3 font-display text-xl font-extrabold uppercase leading-tight text-ink-900 sm:text-2xl" data-id="element-98" data-mp="2azgo6qlunyvo">
                  <span aria-hidden="true" data-id="element-99" data-mp="262giwhwtr05m">{bonus.emoji} </span>
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[15px] font-semibold leading-snug text-ink-700 sm:text-base" data-id="element-100" data-mp="32qmp399ea0m0">
                  {bonus.hook}
                </p>
                {bonus.intro && <p className="mt-3 text-sm font-bold uppercase tracking-wide text-ink-600" data-id="element-101" data-mp="2tp6gn72548kf">
                    {bonus.intro}
                  </p>}
                <ul className="mt-2.5 grid gap-x-5 gap-y-1.5 sm:grid-cols-2" data-id="element-102" data-mp="1ibuinct2ak66">
                  {bonus.items.map(item => <li key={item} className="flex items-start gap-2 text-sm leading-snug text-ink-800 sm:text-[15px]" data-id="element-103" data-mp="1dawsacxwejtl">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green-600" aria-hidden="true" data-id="element-104" data-mp="188fhcxvt47ou" />
                      <span data-id="element-105" data-mp="1hxz3ccetghnx">{item}</span>
                    </li>)}
                </ul>
                {bonus.outro && <p className="mt-4 font-display text-lg font-extrabold uppercase text-gold-600" data-id="element-106" data-mp="1lyj0hfze3la2">
                    {bonus.outro}
                  </p>}
                {bonus.note && <p className="mt-4 flex items-start gap-2 rounded-lg bg-steel-100 px-3 py-2.5 text-xs leading-snug text-ink-700" data-id="element-107" data-mp="1vxzz5dg84ywj">
                    <AlertTriangleIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-600" aria-hidden="true" data-id="element-108" data-mp="1jgylgf8t5h5" />
                    <span data-id="element-109" data-mp="6kegdrwcbxi4">{bonus.note}</span>
                  </p>}
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-110" data-mp="1s140orxh96a8">
          <CTAButton label="Yes — give me all 5 bonuses" sub="$235 in bonuses included free" size="md" data-id="element-111" data-mp="1s2f4usuu4g1v" />
        </div>
      </div>
    </section>;
}